import { startOfDay, subDays } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

export const getDealInsightsSupportedDateRange = () => {
  const zonedTime = toZonedTime(new Date(), 'UTC');

  const maxDate = startOfDay(subDays(zonedTime, 1));
  const minDate = startOfDay(subDays(zonedTime, 180));

  return { maxDate, minDate };
};
